<div style="display: grid; grid-template-columns: 2fr 1fr;">
  <div class="p-3">
    <table class="table" id="credit-statements-table">
      <thead>
        <tr>
          <th>Dokumentnummer</th>
          <th>Ausgestellt am</th>
          <th>Betrag</th>
          <th></th>
        </tr>
      </thead>
  
      <tbody>
        <tr *ngFor="let creditStatement of creditStatements">
          <td>{{ creditStatement.documentNumber }}</td>
          <td>{{ creditStatement.createdAt | dateDE }}</td>
          <td>{{ creditStatement.total | currency:'EUR' }}</td>
          <td><a (click)="download(creditStatement)">
            <app-svg source="icons/feather/download" height="18" style="position: relative; top: -2px"></app-svg>
          </a></td>
        </tr>
        
        <tr *ngIf="creditStatements.length < 1">
          <td colspan="4" class="h-100 py-3 text-center align-middle">
            <svg xmlns="http://www.w3.org/2000/svg" width="48" height="48" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" class="feather feather-info"><circle cx="12" cy="12" r="10"></circle><line x1="12" y1="16" x2="12" y2="12"></line><line x1="12" y1="8" x2="12.01" y2="8"></line></svg><br />
            <span class="pt-3">Keine Einträge vorhanden.</span>
          </td>
        </tr>
      </tbody>
    </table>
  </div>

  <div class="p-3" style="border-left: 1px solid #dee2e6;">
    <label for="users" class="form-label persistent"
      i18n="@@CreditStatementSelectRecipientFromUsers">
      Empfänger aus Benutzern auswählen
    </label>
    <ng-select #userSelect id="user"
      class="mb-3"
      [appendTo]="'body'"
      [items]="users"
      bindLabel="fullName"
      [(ngbModel)]="selectedUser"
      placeholder="Benutzer auswählen"
      i18n-placeholder="@@SelectUsers"
      (change)="loadRecipient()"
    >
    </ng-select>

    <h6>Empfänger</h6>
    <form [formGroup]="form" *ngIf="isFormReady"
      class="mt-2"
      style="display: flex; flex-direction: column; gap: .5rem;">
  
      <input type="text" class="form-control" id="company" formControlName="company" placeholder="Unternehmen" />
      <input type="text" class="form-control" id="ceo" formControlName="ceo" placeholder="Geschäftsführer" />
  
      <div style="display: grid; grid-template-columns: 2fr 1fr; gap: .5rem;">
        <input type="text" class="form-control" id="street" formControlName="street" placeholder="Straße" />
        <input type="text" class="form-control" id="houseNumber" formControlName="houseNumber" placeholder="Hausnummer" />
      </div>
    </form>
  </div>
</div>